"use client"

import React from 'react';
import { useUserContext } from '../context/userContext';

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

export default function UserProfileModal() {

    const {user, logout} = useUserContext();

    const handleLogout = () => {
        logout();
        // setShowUserModal(false);
    }

    return (
        <Menu as="div" className="relative inline-block text-left">
            <div>
                <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-lg bg-white px-3 py-2 text-sm font-normal text-gray-900 border border-gray-200 hover:bg-gray-50 items-center dark:bg-white/10 dark:text-white dark:border-white/10 dark:hover:bg-white/20">
                    {/* <div className='size-6 bg-primary rounded-full flex items-center justify-center '>
                        <p className='text-xs text-secondary-light'>SK</p>
                    </div> */}
                    <p>My Account</p>
                    <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                </MenuButton>
            </div>

            <MenuItems
                transition
                className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-lg bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in dark:divide-gray-700 dark:bg-dark-card dark:ring-white/10"
            >
                <div className="px-4 py-3">
                    <p className="text-sm dark:text-gray-300">Signed in as</p>
                    <p className="truncate text-sm font-medium text-gray-900 dark:text-white">surafelk27@gmail.com</p>
                </div>
                <div className="py-1">
                    <MenuItem>
                        <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none dark:text-gray-300 dark:data-[focus]:bg-white/10 dark:data-[focus]:text-white"
                        >
                        Account settings
                        </a>
                    </MenuItem>
                    <MenuItem>
                        <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none dark:text-gray-300 dark:data-[focus]:bg-white/10 dark:data-[focus]:text-white"
                        >
                        Support
                        </a>
                    </MenuItem>
                    <MenuItem>
                        <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none dark:text-gray-300 dark:data-[focus]:bg-white/10 dark:data-[focus]:text-white"
                        >
                        Cart & Orders
                        </a>
                    </MenuItem>
                </div>
                <div className="py-1">
                    <form action="#" method="POST">
                        <MenuItem>
                        <button
                            onClick={handleLogout}
                            type="submit"
                            className="block w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none dark:text-gray-300 dark:data-[focus]:bg-white/10 dark:data-[focus]:text-white"
                        >
                            Sign out
                        </button>
                        </MenuItem>
                    </form>
                </div>
            </MenuItems>
        </Menu>
    )
}
